"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routesV2 = void 0;
var routesV2 = {
  LEVEL_1A_CONTACT_INFO: '/level/1A/contact-information',
  LEVEL_1A_ACADEMICS: '/level/1A/academics',
  LEVEL_1A_HIGH_SCHOOL: '/level/1A/high-school',
  LEVEL_1A_COLLEGIATE_ATHLETICS: '/level/1A/collegiate-athletics',
  LEVEL_1A_COURSEWORK: '/level/1A/coursework',
  LEVEL_1A_RESEARCH_AND_PROGRAMS: '/level/1A/research-and-programs',
  LEVEL_1A_STUDY_ABROAD: '/level/1A/study-abroad',
  LEVEL_1B_TECHNICAL_SKILLS: '/level/1B/computer-technical',
  LEVEL_1B_LANGUAGES: '/level/1B/languages',
  LEVEL_1B_CERTIFICATES_AND_LICENSES: '/level/1B/certificates-licenses',
  LEVEL_1B_PERSONAL_INTERESTS: '/level/1B/personal-interests',
  LEVEL_1B_DIVERSITIES: '/level/1B/diversities'
};
exports.routesV2 = routesV2;